import { useEffect, useState } from "react";
import { outboxEvents, queuedCount } from "../lib/offline-queue.js";

/* Non-blocking status pill for the offline attempt outbox. Shows "N saved offline"
 * while attempts are queued and a brief "Synced" when the queue clears. Renders
 * nothing when there's nothing to say. */
export function OfflineStatus() {
  const [count, setCount] = useState(0);
  const [justSynced, setJustSynced] = useState(false);

  useEffect(() => {
    let prev = 0;
    let alive = true;
    const refresh = () => {
      queuedCount().then((n) => {
        if (!alive) return;
        if (prev > 0 && n === 0) {
          setJustSynced(true);
          setTimeout(() => alive && setJustSynced(false), 2500);
        }
        prev = n;
        setCount(n);
      });
    };
    refresh();
    outboxEvents.addEventListener("change", refresh);
    window.addEventListener("online", refresh);
    window.addEventListener("offline", refresh);
    return () => {
      alive = false;
      outboxEvents.removeEventListener("change", refresh);
      window.removeEventListener("online", refresh);
      window.removeEventListener("offline", refresh);
    };
  }, []);

  if (count === 0 && !justSynced) return null;
  const synced = count === 0;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        left: "50%",
        bottom: "1rem",
        transform: "translateX(-50%)",
        zIndex: 60,
        maxWidth: "calc(100vw - 2rem)",
        padding: "0.5rem 0.85rem",
        borderRadius: "999px",
        fontSize: "0.8125rem",
        fontWeight: 500,
        whiteSpace: "nowrap",
        color: synced ? "var(--ok, #16a34a)" : "var(--fg, #e5e7eb)",
        background: "var(--surface-raised, rgba(20,22,28,0.95))",
        border: "1px solid var(--border, rgba(255,255,255,0.12))",
        boxShadow: "0 4px 16px rgba(0,0,0,0.35)",
      }}
    >
      {synced ? "Synced" : `${count} answer${count > 1 ? "s" : ""} saved offline. We'll sync when you're back online.`}
    </div>
  );
}
